export default function calendar() {
  const widgetName = 'calendar';
  const widgetOpts = calendarOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    cardWidgetLoaded: function (data) {
      const widgetCount = data.items.length;
      if (widgetCount == 0) {
        $(`#${widgetName}`).remove();
      } else {
        const currentDateStr = new Date().toISOString().split('T')[0];

        $('.days li').each(function () {
          const specifiedDate = $(this).data('date');
          const parsedDate = Date.parse(specifiedDate);

          if (!isNaN(parsedDate)) {
            const formattedDate = new Date(parsedDate).toISOString().split('T')[0];

            if (formattedDate === currentDateStr) {
              $(this).addClass('today');
            } else if (formattedDate < currentDateStr) {
              $(this).addClass('past');
            } else {
              $(this).addClass('future');
            }
          }
        });
      }
    },
    buyNowButton: false,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [],
    maxItemsVisible: 1,
    moreButton: false,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false,
    textOverImage: true,
  });
}
